module.exports = __webpack_public_path__ + "img/coupon_bg.25efcc1c.png";